module.exports = __webpack_public_path__ + "media/images/help/browse_img_4-600d6d69b4569a228501cf850b315e76.jpeg";